import React from 'react';
import './Classes.css';
import { useContext, useEffect } from 'react';
import DataContext from '../context/DataContext';
const Policy = () => {
  const {setNavtrans} = useContext(DataContext);
  useEffect(() => {
    setNavtrans(false);
  });
  // console.log('About');
  return (
    <article className='container'>
      <div className='about'style={{width:"40%",height:"400px",overflowY:"scroll"}}>
        <h1>سياسة الخصوصية</h1>
        <br/>
        <p></p>
        <br/>
        <p></p>
       <br/> 
        <p></p>
        <p></p>
        <br/>
      </div>
    </article>
  )
}

export default Policy;